import { RouteError } from '../error/route-error';

export function routerErrorHandler() {
  throw new RouteError();
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/factories/router-error-handler.factory.ts